import * as React from 'react'

import { ProductPageContext } from './ProductPageContext'

export const useProductPageSku = () => {
  const { product } = React.useContext(ProductPageContext)

  if (!product) {
    throw Error('no sku defined in useProductPageSku')
  }
  return product.sku
}

export const useProductPage = () => {
  return React.useContext(ProductPageContext)
}
